import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { EmailTemplate, EmailSettings } from "./types";

interface PreviewTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  template: EmailTemplate | null;
  emailSettings: EmailSettings | null;
}

export const PreviewTemplateModal: React.FC<PreviewTemplateModalProps> = ({
  isOpen,
  onClose,
  template,
  emailSettings
}) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      size="4xl"
      scrollBehavior="inside"
    >
      <ModalContent>
        <ModalHeader>
          <h3 className="text-lg font-semibold">Voorbeeld: {template?.subject}</h3>
        </ModalHeader>
        <ModalBody>
          {template && (
            <div className="space-y-6">
              {/* Template Info */}
              <div className="grid grid-cols-2 gap-4 p-4 bg-neutral-primary/5 rounded-lg">
                <div>
                  <h4 className="font-medium text-sm text-neutral-secondary-mid mb-1">Type:</h4>
                  <p className="text-neutral-primary">{template.templateType}</p>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-neutral-secondary-mid mb-1">Label:</h4>
                  <p className="text-neutral-primary">{template.label}</p>
                </div>
              </div>
              
              {/* Email Preview */}
              <div>
                <h4 className="font-medium text-sm text-neutral-secondary-mid mb-2">E-mail Voorbeeld:</h4>
                <div className="border border-neutral-primary/20 rounded-lg bg-white">
                  <div className="p-4">
                    {/* Subject Preview */}
                    <div className="mb-4 pb-2 border-b border-neutral-primary/10">
                      <span className="text-xs text-neutral-secondary-mid">Onderwerp:</span>
                      <p className="font-medium text-neutral-primary">{template.subject}</p>
                    </div>
                    
                    {/* Content Preview with Header/Footer */}
                    <div className="prose prose-sm max-w-none">
                      <div dangerouslySetInnerHTML={{ 
                        __html: `
                          ${emailSettings?.headerHtml || ''}
                          ${template.content}
                          ${emailSettings?.footerHtml || ''}
                        `
                      }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={onClose}>
            Sluiten
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}; 